export const SUMMARY = {
  value: "SUMMARY",
};

export const SUMMARY_ONLY = {
  value: "SUMMARY_ONLY",
};

export const PDF = {
  value: "PDF",
};

export const EXCEL = {
  value: "XLS",
};

export default [SUMMARY, SUMMARY_ONLY, PDF, EXCEL];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/enums/invoiceAttachmentsType.js